(() => {
  const setupPricePresets = (root = document) => {
    root.querySelectorAll('.facets__price-presets:not([data-ready])').forEach((presets) => {
      presets.dataset.ready = 'true';
      const details = presets.closest('.facets__disclosure-vertical');
      const minInput = details?.querySelector('price-range input[name$=".gte"]');
      const maxInput = details?.querySelector('price-range input[name$=".lte"]');
      if (!minInput || !maxInput) return;

      const collection = presets.closest('.reference-collection');
      const storageKey = `collection-price-range:${collection?.dataset.collectionUrl || window.location.pathname}`;
      const boundsKey = `${storageKey}:bounds`;
      const storedBounds = JSON.parse(sessionStorage.getItem(boundsKey) || 'null');
      const hasActivePrice = minInput.value !== '' || maxInput.value !== '';
      const currentMinimum = Math.max(0, Math.floor(Number(collection?.dataset.collectionPriceMin) || 0));
      const currentMaximum = Math.max(currentMinimum, Math.ceil(Number(collection?.dataset.collectionPriceMax) || currentMinimum));
      if (!storedBounds && !hasActivePrice) {
        sessionStorage.setItem(boundsKey, JSON.stringify({ min: currentMinimum, max: currentMaximum }));
      }
      const bounds = storedBounds || { min: currentMinimum, max: currentMaximum };
      const minimum = bounds.min;
      const maximum = bounds.max;
      const buttons = [...presets.querySelectorAll('button')];
      const rangeSize = Math.max(1, Math.ceil((maximum - minimum + 1) / buttons.length));
      const formatter = new Intl.NumberFormat('en-IN');

      buttons.forEach((button, index) => {
        const rangeMin = minimum + rangeSize * index;
        const rangeMax = Math.min(maximum, rangeMin + rangeSize - 1);
        button.hidden = rangeMin > maximum;
        if (button.hidden) return;

        button.dataset.priceMin = String(rangeMin);
        button.dataset.priceMax = String(rangeMax);
        button.lastChild.textContent = `₹${formatter.format(rangeMin)}–₹${formatter.format(rangeMax)}`;
      });

      const syncActive = () => {
        const normalize = (value) => {
          const cleanValue = String(value || '').replace(/[^0-9.-]/g, '');
          return cleanValue === '' ? '' : String(Number(cleanValue));
        };
        presets.querySelectorAll('button').forEach((button) => {
          const isActive = normalize(minInput.value) === normalize(button.dataset.priceMin) &&
            normalize(maxInput.value) === normalize(button.dataset.priceMax);
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });
      };

      presets.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const alreadyActive = button.classList.contains('is-active');
          const nextMin = alreadyActive ? '' : button.dataset.priceMin;
          const nextMax = alreadyActive ? '' : button.dataset.priceMax;

          minInput.value = nextMin;
          maxInput.value = nextMax;
          syncActive();
          maxInput.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
      syncActive();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    setupPricePresets();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          setupPricePresets(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
